import React from 'react';
import config from './Config'

import './Features.css';

const Features = () => {
    return (
        <section id="features" className="features">
            <h2 className="features_title">Why Choose {config.brandname}</h2>

            <div className="features_list">
                <div className="features_item">
                    <div className="features_icon">
                    </div>
                    <h3 className="features_name">Device Management</h3>
                    <p className="features_description">
                        Connect, organize, and control all smart home devices from one app.
                    </p>
                </div>

                <div className="features_item">
                    <div className="features_icon">
                    </div>
                    <h3 className="features_name">Remote Control</h3>
                    <p className="features_description">
                        Monitor and operate devices anywhere, anytime via your smartphone.
                    </p>
                </div>

                <div className="features_item">
                    <div className="features_icon">
                    </div>
                    <h3 className="features_name">Cross-Platform Access</h3>
                    <p className="features_description">
                        Available on iOS and Android.
                    </p>
                </div>

            </div>
        </section>
    );
};

export default Features;
